import { Col, Row } from "reactstrap";
import ProfileLayout from "../../../layouts/ProfileLayout";
import { Fragment, useEffect, useState } from "react";
import { API_URL } from "../../../utils/constants";
import { ReactComponent as EmptyIcon } from '../../../assets/images/icons/empty.svg';
import BalanceCard from "../../../components/Cards/BalanceCard";
import { useTranslation } from "react-i18next";
import DefaultButton from "../../../components/Buttons/Default";
import { Link } from "react-router-dom";

function BalancePage() {
  const { t } = useTranslation('balance');
  const [balanceLoading, setBalanceLoading] = useState(true);
  const [balance, setBalance] = useState([]);

  const getSubscriptions = () => {
    setBalanceLoading(true);

    fetch(API_URL+'/user/subscriptions', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => response.json())
    .then(data => {
      setBalanceLoading(false);
      setBalance(data.subscriptions);
    })
    .catch(error => {
      setBalanceLoading(false);
      console.error('Error:', error);
      alert('حدث خطأ أثناء الاشتراك. يرجى المحاولة مرة أخرى.');
    });
  }

  useEffect(() => {
    getSubscriptions();
  }, []);

  return (
    <ProfileLayout>
      <h4 className="mb-4">{t("title")}</h4>

      {balanceLoading ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <Fragment>
          <Row className="g-4">
            {balance?.length > 0 ? (
              balance.map((data, key) => (
                <Col md="4" sm="6" key={key}>
                  <BalanceCard data={data} />
                </Col>
              ))
            ) : (
              <div className="text-center">
                <EmptyIcon />
    
                <h6 className="mt-4 mb-3 fw-normal text-muted">لا توجد باقات متاحة</h6>

                <Link to="/plans">
                  <DefaultButton>
                    تصفح الباقات
                  </DefaultButton>
                </Link>
              </div>
            )}
          </Row>
        </Fragment>
      )}
    </ProfileLayout>
  );
}

export default BalancePage;